import React, { useContext, useEffect, useState } from 'react'
import { CommonDatePicker, CommonInput, CommonSwitch, CommonTextarea } from 'components'
import { UserContext } from 'context';
import { utils } from 'helper';
import StorageService from 'utils/StorageServices/StorageServices';
import { fetchConsigneeDetailsData } from '_services/accountsServices/consigneeServices';
import { fetchSingleUnitData } from '_services/accountsServices/unitServices';
import { getAddressDetailsApi } from '_services/accountsServices/addressBookService';
import AddAddressBook from 'modals/AddAddressBook';
import './lrdetail.css'
import { BsFiletypeXlsx, BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import { FaRegImage } from 'react-icons/fa6';
import { MdOutlineFileDownload, MdOutlineRemoveRedEye } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';
import ImagePreview from './ImagePreview';

const LrDetailsPage = (props) => {

    let { lrData, permissions, materialCategoryList, ewayBillStatusDetails = false } = props;

    const { masterData } = useContext(UserContext);
    const [formValue, setFormValue] = useState({});
    const [selectConsigneeData, setSelectConsigneeData] = useState({})
    const [selectUnitData, setSelectUnitData] = useState({})
    const [dataSingleConsignee, setDataSingleConsignee] = useState({})
    const [dataSingleUnit, setDataSingleUnit] = useState({})

    const [imagePreview, setImagePreview] = useState({});

    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [addressId, setAddressId] = useState({
        id: "",
        title: "address",
        view: false,
    });

    const totalCoutFunction = (name) => {
        if (formValue?.lr_material_list?.length > 0) {
            const total = formValue.lr_material_list.reduce((acc, currTeam) => {
                const value = Number(currTeam[name]);
                return acc + (isNaN(value) ? 0 : value);
            }, 0);
            return Number(total.toFixed(2));
        }
        return 0;
    };

    const getSingleConsigneeData = async (id) => {
        try {
            let object = {
                addressbook_id: id,
                company_id: lrData?.company_id,
            };
            const res = await getAddressDetailsApi(object);
            // let object = {
            //     consignee_id: id,
            //     company_id: lrData?.company_id,
            // }
            // const res = await fetchConsigneeDetailsData(object);
            if (res?.responseCode == 200) {
                setDataSingleConsignee(res?.data?.book_detail)
            }
        } catch (error) {
            // throw error;
        }
    }

    const getSingleUnitData = async (id) => {
        try {
            let object = {
                addressbook_id: id,
                company_id: lrData?.company_id,
            };
            const res = await getAddressDetailsApi(object);
            // let object = {
            //     unit_id: id,
            //     company_id: lrData?.company_id,
            // }
            // const res = await fetchSingleUnitData(object);
            if (res?.responseCode == 200) {
                setDataSingleUnit(res?.data?.book_detail)
            }
        } catch (error) {
            // throw error;
        }
    }

    useEffect(() => {
        if (lrData) {
            let obj = {
                ...lrData,
                invoice_date: lrData?.invoice_date ? new Date(lrData?.invoice_date) : '',
                eway_bill_date: lrData?.eway_bill_date ? new Date(lrData?.eway_bill_date) : '',
                eway_expiry_date: lrData?.eway_expiry_date ? utils.parseUTCAsLocal(lrData?.eway_expiry_date) : ''
            }
            setFormValue(obj);
            setSelectConsigneeData(lrData?.consignee_id);
            setSelectUnitData(lrData?.unit_id);
        }
        if (lrData?.unit_id?._id) {
            getSingleUnitData(lrData?.unit_id?._id);
        }
        if (lrData?.consignee_id?._id) {
            getSingleConsigneeData(lrData?.consignee_id?._id);
        }
    }, [lrData])

    const getTodayDate2 = (date) => {
        const today = new Date(date);
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const callBackAddressData = () => {
        setAddressId((s) => ({
            ...s,
            id: '',
            title: "address",
            view: false,
            isDetailsOnly: false,
        }))
    };

    let storeModelProps = {
        isOpen: imagePreview,
        modalMainClass: '_dashCommon_Modal _mdModal',
        modalTitle: 'Preview',
        submitTitle: 'Preview',
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        modalZIndex: 999999,
        closeModal: (e) => setImagePreview(false),
    }

    return (
        <>

            <div className='pr_addNewLrBx'>
                <div className='pr_procssBx' style={{ marginBottom: '9px' }}>
                    <div className='_lrdMax' style={{ maxWidth: '100%', paddingRight: '30px' }}>
                        <div className="flxInr">
                            <div className="halfDiv">
                                <CommonDatePicker
                                    label="LR Date & Time"
                                    name="invoice_date"
                                    id={Math.random() * 10000}
                                    // showTimeSelect={false}
                                    // defaultTimeFix={false}
                                    startDate={formValue?.invoice_date}
                                    disabled={true}
                                />
                                {/* <CommonInput
                                disabled
                                type="date"
                                label="LR Date & Time * "
                                placeholder="LR Date & Time * "
                                name='invoice_date'
                                min={new Date()}
                                onKeyDown={(e) => e.preventDefault()}
                                value={formValue?.invoice_date ? getTodayDate2(formValue?.invoice_date) : ''}
                            /> */}
                            </div>

                            <div className="halfDiv">
                                <CommonInput
                                    disabled
                                    type="text"
                                    label="LR Number "
                                    placeholder="LR Number "
                                    name='lr_number'
                                    value={formValue?.lr_number ? formValue.lr_number : ''}
                                />
                            </div>

                            <div className="halfDiv">
                                <CommonInput
                                    type="text"
                                    label="Party Name *"
                                    placeholder="Party Name *"
                                    name='name'
                                    value={formValue?.consignor_id?.name ? formValue?.consignor_id?.name : ''}
                                    disabled
                                />
                            </div>

                            <div className="halfDiv">
                                <CommonInput
                                    type="text"
                                    label="Branch Name "
                                    placeholder="Branch Name "
                                    name='name'
                                    value={formValue?.branch_id?.branch ? formValue?.branch_id?.branch : ''}
                                    disabled
                                />
                            </div>

                            <div className="halfDiv">
                                <CommonInput
                                    type="text"
                                    label="From Station  "
                                    placeholder="From Station  "
                                    name='name'
                                    value={formValue.from_location ? `${formValue?.from_location}, ${formValue?.from_state}` : ''}
                                    disabled
                                />
                            </div>

                            <div className="halfDiv">
                                <CommonInput
                                    type="text"
                                    label="To Station "
                                    placeholder="To Station "
                                    name='name'
                                    value={formValue.to_location ? `${formValue?.to_location}, ${formValue?.to_state}` : ''}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className='_csgAdd_bx'>
                            <div className="halfDiv">
                                {
                                    selectUnitData ? (
                                        <div className='_unit_detailBxs _avPointer'>
                                            <div className='flex_extand_avt'>
                                                <span className='extand_address_name'> Unit </span>
                                                <button
                                                    className='view_btn_extand'
                                                    onClick={() => {
                                                        setAddressId({
                                                            ...addressId,
                                                            id: selectUnitData?._id,
                                                            title: "address",
                                                            view: true,
                                                            isDetailsOnly: true,
                                                        });
                                                        setShowOffcanvas(true);
                                                    }}
                                                >
                                                    View
                                                </button>
                                            </div>
                                            <p> Name : {selectUnitData?.name} </p>
                                            <p> Unit code : {selectUnitData?.code} </p>
                                            <p> Address : {dataSingleUnit?.address_line1 ? dataSingleUnit?.address_line1 : '-'} {dataSingleUnit?.city?.label ? dataSingleUnit?.city?.label : '-'} {dataSingleUnit?.state?.label ? dataSingleUnit?.state?.label : '-'} </p>
                                            <p> Pin Code : {dataSingleUnit?.pincode ? dataSingleUnit?.pincode : '-'} </p>
                                        </div>
                                    ) : (
                                        <button className='addConsignee_lBtn' disabled> + Add Unit </button>
                                    )
                                }
                            </div>

                            <div className="halfDiv">
                                {
                                    selectConsigneeData ? (
                                        <div className='_unit_detailBxs'>
                                            <div className='flex_extand_avt'>
                                                <span className='extand_address_name'> Consignee </span>
                                                <button
                                                    className='view_btn_extand'
                                                    onClick={() => {
                                                        setAddressId({
                                                            ...addressId,
                                                            id: selectConsigneeData?._id,
                                                            title: "address",
                                                            view: true,
                                                            isDetailsOnly: true,
                                                        });
                                                        setShowOffcanvas(true);
                                                    }}
                                                >
                                                    View
                                                </button>
                                            </div>
                                            <p> Name : {selectConsigneeData?.name} </p>
                                            <p> Consignee code : {selectConsigneeData?.code} </p>
                                            <p> Address : {dataSingleConsignee?.address_line1 ? dataSingleConsignee?.address_line1 : '-'} {dataSingleConsignee?.city?.label ? dataSingleConsignee?.city?.label : '-'} {dataSingleConsignee?.state?.label ? dataSingleConsignee?.state?.label : '-'} </p>
                                            <p> Pin Code : {dataSingleConsignee?.pincode ? dataSingleConsignee?.pincode : '-'} </p>
                                        </div>
                                    ) : (
                                        <button className='addConsignee_lBtn' disabled>+ Add Consignee</button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {(permissions?.permission_at_item_parent && (permissions?.permission_at_item?.item?.view === 1 ||
                    permissions?.permission_at_item?.item_desc?.view === 1 ||
                    permissions?.permission_at_item?.item_group_hsn?.view === 1 ||
                    permissions?.permission_at_item?.kot?.view === 1 ||
                    permissions?.permission_at_item?.qty?.view === 1 ||
                    permissions?.permission_at_item?.sales?.view === 1 ||
                    permissions?.permission_at_item?.weight?.view === 1)) ?
                    <div className='pr_procssBx' style={{ marginBottom: '9px', marginTop: '30px' }}>
                        <div className='_materialTable'>
                            <table>
                                <thead>
                                    <tr>
                                        {permissions?.permission_at_item?.item_desc?.view === 1 ? <th style={{ width: '16%' }}> Description </th> : <></>}
                                        {permissions?.permission_at_item?.item?.view === 1 ? <th style={{ width: '12%' }}> Material </th> : <></>}
                                        {permissions?.permission_at_item?.item_group_hsn?.view === 1 ? <th style={{ width: '12%' }}>Material Category</th> : <></>}
                                        {permissions?.permission_at_item?.item_group_hsn?.view === 1 ? <th style={{ width: '9%' }}>HSN Code</th> : <></>}
                                        {permissions?.permission_at_item?.qty?.view === 1 ? <th style={{ width: '5%' }}>QTY</th> : <></>}
                                        {permissions?.permission_at_item?.weight?.view === 1 ? <th style={{ width: '5%' }}>Weight</th> : <></>}
                                        {permissions?.permission_at_item?.kot?.view === 1 ? <th style={{ width: '7%' }}>KOT</th> : <></>}
                                        {permissions?.permission_at_item?.sales?.view === 1 ? <th style={{ width: '10%' }}>Amount (₹)</th> : <></>}
                                        <th style={{ width: '1%' }}></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {formValue?.lr_material_list?.length > 0 ?
                                        formValue?.lr_material_list?.map((el, ind) => {
                                            return (
                                                <React.Fragment key={ind}>
                                                    <tr className="__mtrTr_bxs">
                                                        {permissions?.permission_at_item?.item_desc?.view === 1 ?
                                                            <td>
                                                                <CommonInput
                                                                    disabled
                                                                    type="text"
                                                                    // label="Description * "
                                                                    placeholder="Description"
                                                                    name='product_desc'
                                                                    value={el?.product_desc ? el?.product_desc : ''}
                                                                />
                                                            </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.item?.view === 1 ?
                                                            <td>
                                                                <CommonInput
                                                                    disabled
                                                                    type="text"
                                                                    // label="Material * "
                                                                    placeholder="Material"
                                                                    name='hsn_code'
                                                                    value={el?.name ? el?.name : ''}
                                                                />
                                                            </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.item_group_hsn?.view === 1 ?
                                                            <td>
                                                                <CommonInput
                                                                    disabled
                                                                    type="text"
                                                                    // label="Category * "
                                                                    placeholder="Category"
                                                                    name='material_category_id'
                                                                    value={materialCategoryList?.filter((item) => (item?._id === el?.material_category_id) ? item : '')[0]?.name}
                                                                />
                                                            </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.item_group_hsn?.view === 1 ?
                                                            <td>
                                                                <CommonInput
                                                                    disabled
                                                                    type="text"
                                                                    // label="HSN Code"
                                                                    placeholder="HSN Code"
                                                                    name='hsn_code'
                                                                    value={el?.hsn_code ? el?.hsn_code : ''}
                                                                />
                                                            </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.qty?.view === 1 ? <td>
                                                            <div className='_inpSelect llt_weight_input'>
                                                                <CommonInput
                                                                    disabled
                                                                    type="number"
                                                                    // label="Qty "
                                                                    placeholder="Qty "
                                                                    name='qty'
                                                                    value={el?.qty ? el?.qty : ''}
                                                                />

                                                                <select
                                                                    className='_selectInner_bx llt_qty_input'
                                                                    name='qty_type'
                                                                    id='qty_type'
                                                                    disabled
                                                                    defaultValue={el?.qty_type}
                                                                >
                                                                    {
                                                                        masterData?.material_qty_type_list?.map((el, ind) => {
                                                                            return (
                                                                                <option value={el?.id} defaultValue={ind === 0} key={ind}>{el?.name}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.weight?.view === 1 ? <td>
                                                            <div className='_inpSelect llt_weight_input'>
                                                                <CommonInput
                                                                    disabled
                                                                    type="number"
                                                                    // label="Wgt "
                                                                    placeholder="Wgt "
                                                                    name='weight'
                                                                    value={el?.weight ? el?.weight : ''}
                                                                />
                                                                <select
                                                                    className='_selectInner_bx llt_qty_input'
                                                                    name='weight_type'
                                                                    id='weight_type'
                                                                    disabled
                                                                >
                                                                    {
                                                                        masterData?.material_weight_type_list?.map((el, ind) => {
                                                                            return (
                                                                                <option value={el?.id} defaultValue={ind === 0} key={ind}>{el?.name}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.kot?.view === 1 ? <td>
                                                            <CommonInput
                                                                disabled
                                                                type="number"
                                                                // label="KOT "
                                                                placeholder="KOT "
                                                                name='kot'
                                                                value={el?.kot ? el?.kot : ''}
                                                            />
                                                        </td>
                                                            :
                                                            <></>
                                                        }
                                                        {permissions?.permission_at_item?.sales?.view === 1 ?
                                                            <td>
                                                                <CommonInput
                                                                    disabled
                                                                    type="number"
                                                                    // label="Amount (₹)"
                                                                    placeholder="Amount (₹)"
                                                                    name='amount'
                                                                    value={el?.amount ? el?.amount : ''}
                                                                />
                                                            </td>
                                                            :
                                                            <></>
                                                        }
                                                        <td>
                                                            {formValue?.lr_material_list?.length !== 1 && (
                                                                <p
                                                                    className="faTrash_cls"
                                                                >

                                                                </p>
                                                            )}
                                                        </td>
                                                    </tr>
                                                    {
                                                        (formValue?.lr_material_list?.length - 1 === ind) && (
                                                            <tr style={{ position: 'relative' }}>
                                                                {permissions?.permission_at_item?.item_desc?.view === 1 ? <td></td> : <></>}
                                                                {permissions?.permission_at_item?.item?.view === 1 ? <td></td> : <></>}
                                                                {permissions?.permission_at_item?.item_group_hsn?.view === 1 ? <td></td> : <></>}
                                                                {permissions?.permission_at_item?.item_group_hsn?.view === 1 ? <td></td> : <></>}
                                                                {permissions?.permission_at_item?.qty?.view === 1 ?
                                                                    <td align="right">
                                                                        {totalCoutFunction("qty")} Qty{" "}
                                                                    </td> : <></>}

                                                                {permissions?.permission_at_item?.weight?.view === 1 ?
                                                                    <td align="right">
                                                                        {totalCoutFunction("weight") > 0 ? totalCoutFunction("weight") / 1000 : 0} {permissions?.permission_at_item?.total_weight_type ? masterData.material_weight_type[permissions?.permission_at_item?.total_weight_type] : 'TON'}{" "}
                                                                    </td> : <></>}

                                                                {permissions?.permission_at_item?.kot?.view === 1 ?
                                                                    <td align="right">
                                                                        {" "}
                                                                        {totalCoutFunction("kot")} kot{" "}
                                                                    </td>
                                                                    : <></>}
                                                                {permissions?.permission_at_item?.sales?.view === 1 ?
                                                                    <>
                                                                        {
                                                                            ewayBillStatusDetails ?
                                                                                <td align="right">
                                                                                    <div> {totalCoutFunction("amount")} ₹{" "} </div>
                                                                                    <div> <span className="_gst_color"> CGST </span> {lrData?.eway_details?.cgstValue > 0 ? lrData?.eway_details?.cgstValue : 0} ₹{" "}</div>
                                                                                    <div> <span className="_gst_color"> SGST </span> {lrData?.eway_details?.sgstValue > 0 ? lrData?.eway_details?.sgstValue : 0} ₹{" "}</div>
                                                                                    <div> <span className="_gst_color"> IGST </span> {lrData?.eway_details?.igstValue > 0 ? lrData?.eway_details?.igstValue : 0} ₹{" "}</div>
                                                                                    <div> <span className="_gst_color"> Total </span> {lrData?.eway_details?.totInvValue > 0 ? lrData?.eway_details?.totInvValue : 0} ₹{" "}</div>
                                                                                </td>
                                                                                :
                                                                                <td align="right">
                                                                                    {" "}
                                                                                    {totalCoutFunction("amount")} ₹{" "}
                                                                                </td>
                                                                        }


                                                                    </>
                                                                    : <></>}
                                                                <td>
                                                                    <div style={{ minHeight: '20px' }}>
                                                                        <div style={{ position: 'absolute', left: '18px', top: '6px' }}> Total</div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </React.Fragment>
                                            )
                                        }) :
                                        <></>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div> : <></>}

                <div className='pr_procssBx __docPrx_bx' style={{ marginBottom: "20px", marginRight: '30px' }}>
                    <div className="_inrPrt_flx2 ">
                        <div className="singleDiv">
                            <p>Document Details</p>
                        </div>

                        {permissions?.permission_at_invoice_number?.view === 1 && <div className="halfDiv">
                            <CommonInput
                                disabled
                                type="text"
                                label={permissions?.permission_at_invoice_number?.mandatory === 1 ? "Invoice Number * " : "Invoice Number"}
                                placeholder={permissions?.permission_at_invoice_number?.mandatory === 1 ? "Invoice Number * " : "Invoice Number"}
                                name='invoice_number'
                                value={formValue?.invoice_number ? formValue?.invoice_number : ''}
                            />
                        </div>}

                        {permissions?.permission_at_field2?.view === 1 && <div className="halfDiv">
                            <CommonInput
                                disabled
                                type="text"
                                label={permissions?.permission_at_field2?.mandatory === 1 ? (permissions?.permission_at_field2?.field_name ? `${permissions?.permission_at_field2?.field_name} *` : "SAP Invoice Number * ") : (permissions?.permission_at_field2?.field_name ? `${permissions?.permission_at_field2?.field_name}` : "SAP Invoice Number ")}
                                placeholder={permissions?.permission_at_field2?.mandatory === 1 ? (permissions?.permission_at_field2?.field_name ? `${permissions?.permission_at_field2?.field_name} *` : "SAP Invoice Number * ") : (permissions?.permission_at_field2?.field_name ? `${permissions?.permission_at_field2?.field_name}` : "SAP Invoice Number ")}
                                name='sap_invoice_number'
                                value={formValue?.sap_invoice_number ? formValue.sap_invoice_number : ""}
                            />
                        </div>}

                        {permissions?.permission_at_field3?.view === 1 && <div className="halfDiv">
                            <CommonInput
                                disabled
                                type="text"
                                label={permissions?.permission_at_field3?.mandatory === 1 ? (permissions?.permission_at_field3?.field_name ? `${permissions?.permission_at_field3?.field_name} *` : "GST Number *") : (permissions?.permission_at_field3?.field_name ? `${permissions?.permission_at_field3?.field_name}` : "GST Number ")}
                                placeholder={permissions?.permission_at_field3?.mandatory === 1 ? (permissions?.permission_at_field3?.field_name ? `${permissions?.permission_at_field3?.field_name} *` : "GST Number *") : (permissions?.permission_at_field3?.field_name ? `${permissions?.permission_at_field3?.field_name}` : "GST Number ")}
                                maxLength={permissions?.permission_at_field3?.input_length ? permissions?.permission_at_field3?.input_length : '10'}
                                name='gst_invoice_number'
                                value={formValue?.gst_invoice_number ? formValue.gst_invoice_number : ''}
                            />
                        </div>}

                        {permissions?.permission_at_field4?.view === 1 && <div className="halfDiv">
                            <CommonInput
                                disabled
                                type="text"
                                label={permissions?.permission_at_field4?.mandatory === 1 ? (permissions?.permission_at_field4?.field_name ? `${permissions?.permission_at_field4?.field_name} *` : "PO Number *") : (permissions?.permission_at_field4?.field_name ? `${permissions?.permission_at_field4?.field_name}` : "PO Number ")}
                                placeholder={permissions?.permission_at_field4?.mandatory === 1 ? (permissions?.permission_at_field4?.field_name ? `${permissions?.permission_at_field4?.field_name} *` : "PO Number *") : (permissions?.permission_at_field4?.field_name ? `${permissions?.permission_at_field4?.field_name}` : "PO Number ")}
                                maxLength={permissions?.permission_at_field4?.input_length ? permissions?.permission_at_field4?.input_length : '10'}
                                name='po_number'
                                value={formValue?.po_number ? formValue.po_number : ''}
                            />
                        </div>}

                        {permissions?.permission_at_field5?.view === 1 && <div className="halfDiv">
                            <CommonInput
                                disabled
                                type="text"
                                label={permissions?.permission_at_field5?.mandatory === 1 ? (permissions?.permission_at_field5?.field_name ? `${permissions?.permission_at_field5?.field_name} *` : "MLR Number *") : (permissions?.permission_at_field5?.field_name ? `${permissions?.permission_at_field5?.field_name}` : "MLR Number ")}
                                placeholder={permissions?.permission_at_field5?.mandatory === 1 ? (permissions?.permission_at_field5?.field_name ? `${permissions?.permission_at_field5?.field_name} *` : "MLR Number *") : (permissions?.permission_at_field5?.field_name ? `${permissions?.permission_at_field5?.field_name}` : "MLR Number ")}
                                maxLength={permissions?.permission_at_field5?.input_length ? permissions?.permission_at_field5?.input_length : '10'}
                                name='mlr_number'
                                value={formValue?.mlr_number ? formValue.mlr_number : ''}
                            />
                        </div>}
                    </div>
                </div>

                {/* <div className='pr_procssBx' style={{ marginBottom: '9px' }}>
                <div className="_inrPrt_flx2 ">
                    <div className='singleDiv'>
                        Eway Bill
                    </div>
                    <div className="_divForth">
                        <CommonInput
                            disabled
                            type="number"
                            label="Eway Bill Number * "
                            placeholder="Eway Bill Number * "
                            name='eway_bill_number'
                            value={formValue?.eway_bill_number ? formValue.eway_bill_number : ""}
                        />
                    </div>

                    {(formValue?.eway_bill_number?.toString()?.length === 12) ?
                        <>
                            <div className="_divForth">
                                <CommonDatePicker
                                    label="Start Date"
                                    name='eway_bill_date'
                                    id={Math.random() * 10000}
                                    placeholderText='Start Date'
                                    showTimeSelect={false}
                                    defaultTimeFix={false}
                                    startDate={formValue.eway_bill_date}
                                    disabled={true}
                                />
                            </div>

                            <div className="_divForth">
                                <CommonDatePicker
                                    label="End Date"
                                    name='eway_expiry_date'
                                    id={Math.random() * 10000}
                                    placeholderText='End Date'
                                    showTimeSelect={false}
                                    defaultTimeFix={true}
                                    startDate={formValue.eway_expiry_date}
                                    disabled={true}
                                />
                            </div>
                        </>
                        :
                        <></>
                    }
                </div>
            </div> */}

                {(permissions?.contract?.chargeable_on === 1) && <div className="pr_procssBx __docPrx_bx" style={{ marginBottom: "9px", marginRight: '30px' }}>
                    <div className="_inrPrt_flx2 ">
                        <div className='singleDiv'>
                            <CommonSwitch
                                id="freightReceivable"
                                name="Freight Receivable from Party"
                                label="Freight Receivable from Party"
                                disabled={true}
                                hideSwitchIconShow={false}
                            />
                        </div>

                        <div className='_divForth'>
                            <CommonInput
                                disabled
                                type="text"
                                label="Freight Type"
                                placeholder="Freight Type "
                                name='freight_type'
                                value={permissions?.contract?.rate_type?.find((el) => (el?.id == formValue?.lr_freight?.freight_type ? el : ''))?.name}
                            />
                        </div>

                        {formValue?.lr_freight?.freight_type != 6 && (
                            <>
                                <div className="_divForth">
                                    <CommonInput
                                        disabled
                                        type="number"
                                        label="Qty"
                                        placeholder="Qty "
                                        name='total_qty'
                                        value={formValue?.lr_freight?.qty ? formValue?.lr_freight?.qty : ''}
                                    />
                                </div>

                                <div className="_divForth">
                                    <CommonInput
                                        disabled
                                        type="number"
                                        label="Rate"
                                        placeholder="Rate "
                                        name='rate'
                                        value={formValue?.lr_freight?.rate ? formValue?.lr_freight?.rate : ''}
                                    />
                                </div>
                            </>
                        )}

                        <div className="_divForth">
                            <CommonInput
                                disabled
                                type="number"
                                label="Amount (₹)"
                                placeholder="Amount "
                                name='total_amount'
                                value={(formValue?.lr_freight?.rate * formValue?.lr_freight?.qty > 0 && formValue?.lr_freight?.rate * formValue?.lr_freight?.qty != null) ? (formValue?.lr_freight?.rate * formValue?.lr_freight?.qty) : (formValue?.lr_freight?.total_freight ? formValue?.lr_freight?.total_freight : "")}
                            />
                        </div>

                    </div>
                </div>}



            </div>

            <div className='rightNw_lrbx'>
                <div className="Cbox_border_lr ">
                    <h6>Eway Bill Details</h6>

                    <div className="_csgAdd_bx">
                        <div className="singleDiv mt-3">
                            <CommonInput
                                disabled
                                type="number"
                                label="Eway Bill Number * "
                                placeholder="Eway Bill Number * "
                                name='eway_bill_number'
                                value={formValue?.eway_bill_number ? formValue.eway_bill_number : ""}
                            />
                        </div>

                        {(formValue?.eway_bill_number?.toString()?.length === 12) ?
                            <React.Fragment className='mt-3'>
                                <div className="singleDiv mt-4">
                                    <CommonDatePicker
                                        label="Start Date"
                                        name='eway_bill_date'
                                        id={Math.random() * 10000}
                                        placeholderText='Start Date'
                                        showTimeSelect={false}
                                        defaultTimeFix={false}
                                        startDate={formValue.eway_bill_date}
                                        disabled={true}
                                    />
                                </div>

                                <div className="singleDiv mt-4">
                                    <CommonDatePicker
                                        label="End Date"
                                        name='eway_expiry_date'
                                        id={Math.random() * 10000}
                                        placeholderText='End Date'
                                        showTimeSelect={false}
                                        defaultTimeFix={true}
                                        startDate={formValue.eway_expiry_date}
                                        disabled={true}
                                    />
                                </div>
                            </React.Fragment>
                            :
                            <></>
                        }
                    </div>
                </div>

                <div className="mt-4">
                    <CommonTextarea
                        type="textarea"
                        label='Remarks'
                        placeholder='Remarks'
                        name='remarks'
                        disabled
                        value={formValue.remarks}
                        // focus={!!(typeof formError === "object" && formError?.remarks)}
                        // error={!!(typeof formError === "object") ? formError?.remarks : ""}
                        maxLength="500"
                    // onInput={utils.maxLengthCheck}
                    // onChange={({ target: { name, value } }) =>
                    //   handleOnChange(name, value)
                    // }
                    />
                </div>


                <div className="_inrPrt_flx3 mt-2">
                    {/* <div className="singleDiv">
                            <span> Attachment </span>
                        </div> */}
                    <div className="singleDiv ">
                        {/* <label className="attachFilelabel">
                            <span className="title"> View Attachment </span>
                            <input
                                className="FileUpload1"
                                name="booking_attachment"
                                id="file-input"
                                type="file"
                                disabled
                            />
                        </label> */}
                        {formValue?.attachment_file?.length > 0 ? formValue?.attachment_file?.map((file, index) => (
                            < div className='img_fnex_src _rmRf_pd_file' key={index} >
                                <div className='__upFileDetail'>
                                    <div className='__uplImg'>

                                        {
                                            file?.path?.split('.')?.at(-1) === 'pdf' ?
                                                <span className='pdf_clsr-ct'>
                                                    <BsFillFileEarmarkPdfFill />
                                                </span>
                                                : (file?.path?.split('.')?.at(-1) === 'xlsx' || file?.path?.split('.')?.at(-1) === 'xls' || file?.path?.split('.')?.at(-1) === 'txt') ?
                                                    <span className='xlsx_clsr-ct'>
                                                        <BsFiletypeXlsx />
                                                    </span> :
                                                    <span className='__uplImg-ct'>
                                                        <FaRegImage />
                                                    </span>
                                        }
                                        <p>{`${file?.filename}`}</p>
                                    </div>
                                    <div className='__uplIcons _avPointer'>
                                        {
                                            !(file?.path?.split('.')?.at(-1) === 'pdf' || file?.path?.split('.')?.at(-1) === 'xlsx' || file?.path?.split('.')?.at(-1) === 'xls' || file?.path?.split('.')?.at(-1) === 'txt') &&
                                            <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${file?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />
                                        }

                                        <a href={`${masterData?.s3_url}${file?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                                            <MdOutlineFileDownload />
                                        </a>
                                        {/* <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => documentRemove(file?.path)}>
                                            <RxCross2 />
                                        </span> */}
                                    </div>
                                </div>
                            </div>
                        )) : <></>}
                    </div>
                </div>

            </div>


            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
            >
                {showOffcanvas && (
                    <AddAddressBook
                        isOpen={showOffcanvas}
                        onClose={(e) => {
                            setAddressId({ id: "", title: "address", view: false });
                            setShowOffcanvas(false);
                        }}
                        id={addressId}
                        callBackAddressData={callBackAddressData}
                        hideAddNewOption={false}
                    />
                )}
            </div>
            <div className={showOffcanvas ? "offBack_drop" : ""}></div>


            {/* Attachement View Modal Start */}
            {
                imagePreview?.preview
                && (
                    <ImagePreview {...storeModelProps} />
                )
            }
            {/* Attachement View Modal End */}

        </>
    )
}

export default React.memo(LrDetailsPage)
